import { Endpoints, EnvironmentUrls } from 'Roblox';

const { thumbnailsApi } = EnvironmentUrls;

export const getAvatarThumbnail3dJsonUrl = (userId: number) =>
  Endpoints.getAbsoluteUrl(`${thumbnailsApi}/v1/users/avatar-3d?userId=${userId}`);
